document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.sw-campaign-form[data-ready="true"] [data-checkout-submit]').forEach(button => { button.hidden = false; });
});
document.addEventListener('submit', async event => {
  const form = event.target.closest('.sw-campaign-form');
  if (!form) return;
  event.preventDefault();
  if (form.dataset.ready !== 'true' || !form.reportValidity()) return;
  const selected = form.querySelector('input[name="gift_variant"]:checked');
  if (!selected) return;
  const button = form.querySelector('[data-checkout-submit]');
  const status = form.querySelector('[data-cart-status]');
  if (button.disabled) return;
  button.disabled = true;
  status.hidden = true;
  try {
    const response = await fetch(form.dataset.cartUrl + '.js', { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Cart unavailable');
    const cart = await response.json();
    if (!Array.isArray(cart.items)) throw new Error('Invalid cart');
    if (cart.items.some(item => String(item.product_id) !== form.dataset.productId)) {
      status.replaceChildren(document.createTextNode(form.dataset.cartMessage + ' '));
      const link = document.createElement('a');
      link.href = form.dataset.cartUrl;
      link.textContent = form.dataset.cartLink;
      status.appendChild(link);
      status.hidden = false;
      return;
    }
    window.location.assign(form.dataset.cartUrl + '/' + encodeURIComponent(selected.value) + ':1?attributes%5BCampaign%5D=' + encodeURIComponent(form.dataset.campaign));
  } catch {
    status.textContent = form.dataset.errorMessage;
    status.hidden = false;
  } finally {
    button.disabled = false;
  }
});

